import { createFileRoute } from '@tanstack/react-router';

import { ProviderListPage } from '@frontend/features/providers/components/ProviderListPage';

export const Route = createFileRoute('/provider-network/providers/')({
  component: ProviderListPage,
});
